import { gql } from 'apollo-boost';

export const FIND_DISCOUNT_BY_CODE_GQL = gql`
  query doFindDiscountByCode($code: String!) {
    findDiscountByCode(code: $code) {
      id
      code
      type
      value
      discountAttribute {
        title
      }
    }
  }
`;
